import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../../hooks/UserContext";

const ProtectedRoute = ({ element: Component, roleRequired, allowedRoles }) => {
  const { user, isAuthenticated, loading } = useContext(UserContext);

  // Afficher un loader pendant le chargement
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rose-500"></div>
      </div>
    );
  }

  // Si l'utilisateur n'est pas connecté
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: window.location.pathname }} />;
  }

  // Si un rôle spécifique est requis
  if (roleRequired !== undefined) {
    if (user.id_role === roleRequired) {
      return Component;
    }
    return <Navigate to="/404" />;
  }

  // Si plusieurs rôles sont autorisés
  if (allowedRoles && Array.isArray(allowedRoles)) {
    if (allowedRoles.includes(user.id_role)) {
      return Component;
    }
    return <Navigate to="/404" />;
  }

  // Par défaut, si juste authentifié
  return Component;
};

export default ProtectedRoute;